const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export const parseFilename = (contentDisposition: string) => {
    const matches = filenameRegex.exec(contentDisposition);
    return matches?.[1] ?? "watchtower-interactions.csv";
};
